import React from "react";
import { shallow } from "zustand/shallow";
import { NumberInput } from "@mantine/core";

import useAppStore from "./report-recipe-runner-store";

import { CustomTooltip } from "@components/shared";

export default function QbNumberField({ field }) {
  const { queryData, queryComponents, setQueryData } = useAppStore(
    (state) => ({
      queryData: state.query_data,
      queryComponents: state.query_components,
      setQueryData: state.setQueryData,
    }),
    shallow
  );

  return (
    <NumberInput
      labelProps={{
        labelElement: "div",
        style: {
          display: "flex",
          alignItems: "center",
          gap: "6px",
        },
      }}
      label={
        field.tooltip_text ? (
          <CustomTooltip label={field.tooltip_text}>
            <label>{field.label}</label>
          </CustomTooltip>
        ) : (
          <label>{field.label}</label>
        )
      }
      required={field.required}
      min={field.min_value || 0}
      max={field.max_value || 0}
      value={queryData[field.clientName]}
      onChange={(e) =>
        setQueryData({
          ...queryData,
          [field.clientName]: e,
        })
      }
    />
  );
}
